import React, { useState, useEffect } from 'react';

const API = '/api';

export default function LimitesZonal({ usuario }) {
  const [zonales, setZonales] = useState([]);
  const [config, setConfig] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState({});
  const [msg, setMsg] = useState(null);
  const [filterCop, setFilterCop] = useState('');

  const fetchData = () => {
    fetch(`${API}/zonal-config`)
      .then(r => r.json())
      .then(data => {
        setZonales(data);
        const cfgMap = {};
        data.forEach(z => { cfgMap[z.zonal] = z; });
        setConfig(cfgMap);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

  useEffect(() => { fetchData(); }, []);

  const showMsg = (ok, txt) => {
    setMsg({ ok, txt });
    setTimeout(() => setMsg(null), 3000);
  };

  const guardar = async (zonal, soc_limite, activo) => {
    setSaving(prev => ({ ...prev, [zonal]: true }));
    try {
      const resp = await fetch(`${API}/zonal-config`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'x-user-email': usuario.email },
        body: JSON.stringify({ zonal, soc_limite, activo })
      });
      const data = await resp.json();
      if (data.ok) {
        setConfig(prev => ({ ...prev, [zonal]: { zonal, soc_limite, activo } }));
        showMsg(true, `Límite de ${zonal} guardado: ${soc_limite}%`);
      } else showMsg(false, data.error || 'Error');
    } catch (e) { showMsg(false, 'Error de conexión'); }
    setSaving(prev => ({ ...prev, [zonal]: false }));
  };

  const getLimite = (zonal) => config[zonal]?.soc_limite ?? 100;
  const getActivo = (zonal) => config[zonal]?.activo ?? 0;

  const zonalesFiltrados = zonales.filter(z => !filterCop || z.cop === filterCop);
  const totalConLimite = Object.values(config).filter(c => c.activo && c.soc_limite < 100).length;

  if (loading) return <div style={{ padding: '3rem', textAlign: 'center', color: 'var(--text3)' }}>Cargando zonales...</div>;

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem', flexWrap: 'wrap', gap: '12px' }}>
        <div className="page-title" style={{ margin: 0 }}>Límites de carga por zonal</div>
        <select value={filterCop} onChange={e => setFilterCop(e.target.value)}>
          <option value="">Todos los COP</option>
          <option value="Blanco y Negro">Blanco y Negro</option>
        </select>
      </div>

      <div className="metrics">
        <div className="metric-card">
          <div className="metric-label">Zonales registrados</div>
          <div className="metric-value">{zonales.length}</div>
        </div>
        <div className="metric-card">
          <div className="metric-label">Con límite activo</div>
          <div className="metric-value" style={{ color: 'var(--accent)' }}>{totalConLimite}</div>
        </div>
        <div className="metric-card">
          <div className="metric-label">Sin límite</div>
          <div className="metric-value" style={{ color: 'var(--text3)' }}>{zonales.length - totalConLimite}</div>
        </div>
      </div>

      {msg && (
        <div style={{ background: msg.ok ? 'var(--accent3)' : 'rgba(248,113,113,0.1)', border: `1px solid ${msg.ok ? 'var(--accent)' : '#f87171'}`, borderRadius: '8px', padding: '10px 16px', marginBottom: '1.25rem', fontSize: '13px', color: msg.ok ? 'var(--accent)' : '#f87171' }}>
          {msg.ok ? '✅' : '❌'} {msg.txt}
        </div>
      )}

      <div className="card">
        <div style={{ fontSize: '12px', color: 'var(--text3)', marginBottom: '1rem' }}>
          💡 Cuando un bus llega al SoC límite configurado, el servidor detiene la carga automáticamente. Usa 100% para sin límite.
        </div>
        <table>
          <thead>
            <tr>
              <th>Zonal</th>
              <th>COP</th>
              <th>Límite SoC (%)</th>
              <th>Activo</th>
              <th>Guardar</th>
            </tr>
          </thead>
          <tbody>
            {zonalesFiltrados.map(z => {
              const limite = getLimite(z.zonal);
              const activo = getActivo(z.zonal);
              return (
                <tr key={z.zonal}>
                  <td style={{ color: 'var(--accent)', fontWeight: '600' }}>{z.zonal}</td>
                  <td style={{ color: 'var(--text2)', fontSize: '12px' }}>{z.cop}</td>
                  <td>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <input
                        type="number" min="50" max="100"
                        defaultValue={limite}
                        id={`limite-${z.zonal}`}
                        style={{ width: '70px', textAlign: 'center' }}
                      />
                      <span style={{ fontSize: '12px', color: 'var(--text3)' }}>%</span>
                    </div>
                  </td>
                  <td>
                    <input
                      type="checkbox"
                      id={`activo-${z.zonal}`}
                      defaultChecked={activo === 1}
                    />
                  </td>
                  <td>
                    <button
                      onClick={() => {
                        const limiteVal = parseInt(document.getElementById(`limite-${z.zonal}`).value);
                        const activoVal = document.getElementById(`activo-${z.zonal}`).checked ? 1 : 0;
                        guardar(z.zonal, limiteVal, activoVal);
                      }}
                      disabled={saving[z.zonal]}
                      style={{ padding: '4px 12px', background: 'var(--accent-dark)', border: '1px solid var(--accent)', borderRadius: '6px', color: '#fff', cursor: 'pointer', fontSize: '12px', fontWeight: '600' }}>
                      {saving[z.zonal] ? '⏳' : '💾 Guardar'}
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
